import type { Maybe } from '@adornis/base/utilTypes.js';
import type { SalaryTable } from '../entities/SalaryTable.js';
import { type SalaryTableLevels } from '../enum/SalaryTableLevels.js';
import type { SalaryTableRow } from '../enum/SalaryTableRow.js';
import { getSalaryRowLevelIndex, type SalaryTableRowKeys } from '../enum/SalaryTableRowKeys.js';

export type SalaryKeyRecord = { [k in SalaryTableRowKeys]: SalaryTable };

export function getSalaryRowLevelValue(levelStack: Maybe<SalaryTableRow>, targetLevel: SalaryTableLevels) {
  const targetIndex = getSalaryRowLevelIndex(targetLevel);

  if (0 <= targetIndex && targetIndex < (levelStack?.length ?? 0))
    return levelStack ? levelStack[targetIndex] : undefined;
}
export function mappingSalaryTableByKey(rows: SalaryTable[]): SalaryKeyRecord {
  return Object.fromEntries(rows.map(curRow => [curRow.key, curRow]));
}
